<template>
	<div :class="['price-table', {'price-table--only-once-product': !!onlyProductId}]">
		<Loading v-if="loading"/>
		<template v-else>
			<div class="d-lg-none">
				<div
					v-for="product in productsMobile"
					:key="product ? product.id : 'free'"
					class="price-table--item"
				>
					<div class="price-table--header">
						<div :class="['price-table--header-item', getProductsHeaderBackgroundClass(product)]">
							{{ product ? product.label : 'Test' }}
						</div>
					</div>
					<div class="price-table--feature-content">
						<div class="price-table--feature">
							<Icon icon="checkmark" :color="getProductColor(product)"/>
							Unlimitierte Jobs
						</div>
						<div class="price-table--feature">
							<Icon icon="checkmark" :color="getProductColor(product)"/>
							Unlimitierte Filter
						</div>
						<div class="price-table--feature">
							<Icon icon="checkmark" :color="getProductColor(product)"/>
							Best-Match-System
						</div>
						<div class="price-table--feature">
							<Icon icon="checkmark" :color="getProductColor(product)"/>
							Bewerbermanagement
						</div>
						<div class="price-table--feature">
							<Icon icon="checkmark" :color="getProductColor(product)"/>
							Kontaktsystem
						</div>
						<div class="mt-3">
							<span :class="['font-size-big4', 'font-weight-bold', 'color-' + getProductColor(product)]">
								<template v-if="product">
									{{ product.contactingsPerMonth ? product.contactingsPerMonth : 'Unlimitiert' }}
								</template>
								<template v-else>0</template>
							</span>
							Kontaktierungen pro Monat
						</div>
						<div v-if="!product" class="price-table--feature-content-price">
							<Free/>
						</div>
						<div v-else class="price-table--feature-content-price">
							<BuyButton
								v-if="product && withPrices"
								:product="product"
								:upgradable-items="upgradableItems"
								:chosen-product="chosenProduct"
								:custom-button-click-handler="customButtonClickHandler"
								@buy="$emit('buy', $event)"
							/>
						</div>
					</div>
				</div>
				<div v-if="withPrices" class="mt-4 font-size-smaller">Alle Preise in EURO exkl. USt.</div>
			</div>
			<div class="d-none d-lg-block">
				<div class="price-table--header">
					<div>&nbsp;</div>
					<div v-if="withFree" class="price-table--header-item bg-color-purple">Test</div>
					<div
						v-for="product in products"
						:key="product.id"
						:class="['price-table--header-item', getProductsHeaderBackgroundClass(product)]"
					>
						{{ product.label }}
					</div>
				</div>
				<Feature
					:with-free="withFree"
					text="Unlimitierte Jobs:"
					:products="products"
					free-checked
				/>
				<Feature
					:with-free="withFree"
					text="Unlimitierte Filter:"
					:products="products"
					free-checked
				/>
				<Feature
					:with-free="withFree"
					text="Best-Match-System:"
					:products="products"
					free-checked
				/>
				<Feature
					:with-free="withFree"
					text="Bewerbermanagement:"
					:products="products"
					free-checked
				/>
				<Feature
					:with-free="withFree"
					text="Kontaktsystem:"
					:products="products"
					free-checked
				/>
				<Feature
					:with-free="withFree"
					text="Anzahl Kontaktierungen:"
					sub-text="pro Monat"
					:products="products"
					type="content"
					:content-provider="product => product.contactingsPerMonth || 'unlimitiert'"
				/>
				<Feature
					v-if="withPrices"
					:with-free="withFree"
					text="Alle Preise in EURO exklusive USt."
					:products="products"
					type="price"
					:custom-button-click-handler="customButtonClickHandler"
					:chosen-product="chosenProduct"
					:upgradable-items="upgradableItems"
					@buy="$emit('buy', $event)"
				/>
			</div>
		</template>
	</div>
</template>

<script>
import Loading from "@/vue/common/Loading.vue";
import Feature from "./price-table/Feature.vue";
import GetList from "@/api/product/GetList";
import {SUBSCRIPTION} from "@/helper/product/Category";
import {PRODUCT_COLORS} from "@/helper/product/Product";
import Icon from "@/vue/icon/Icon.vue";
import _ from "lodash";
import BuyButton from "@/vue/payment/price-table/BuyButton.vue";
import Button from "@/vue/common/Button.vue";
import Free from "@/vue/payment/price-table/Free.vue";

export default {
	components: {Free, Button, BuyButton, Icon, Feature, Loading},

	props: {
		withFree: {
			type: Boolean,
			required: false,
			default: true,
		},
		withPrices: {
			type: Boolean,
			required: false,
			default: true,
		},
		customButtonClickHandler: {
			type: Boolean,
			required: false,
			default: false,
		},
		chosenProduct: {
			type: Object,
			required: false
		},
		upgradableItems: {
			type: Array,
			required: false
		},
		onlyProductId: {
			type: String,
			required: false
		}
	},

	mounted ()
	{
		this.loadPrices();
	},

	data ()
	{
		return {
			loading: true,
			products: undefined,
		};
	},

	computed: {
		productsMobile ()
		{
			return _.concat(this.withFree ? [null] : [], this.products);
		},
	},

	methods: {
		async loadPrices ()
		{
			this.loading = true;

			const response = await new GetList()
				.setCategory(SUBSCRIPTION)
				.call();

			let products = response.data;

			if (this.onlyProductId)
			{
				products = products.filter(p => p.id === this.onlyProductId);
			}

			this.products = products;

			this.loading = false;
		},
		getProductColor (product)
		{
			if (!product)
			{
				return 'purple';
			}

			return PRODUCT_COLORS[product.id];
		},
		getProductsHeaderBackgroundClass (product)
		{
			const color = product
				? PRODUCT_COLORS[product.id]
				: 'purple';

			return 'bg-color-' + color;
		}
	}
}
</script>
